//CourseStoreOptionsTogle.jsx

import React from 'react'

export const CourseOptionsToggle = ({ icon, options, currentOption, setOption, grayTitle, lavenderTitle }) => (
    <div className="flex flex-col gap-[36px]">
        <div className="text-sub-title  text-[24px] sm:text-[32px] dark:text-white font-semibold">
            {grayTitle}{' '}
            <span className="text-lavender">{lavenderTitle}</span>
        </div>

        <div className="flex gap-[10px] break-p-700:gap-[26px]">
            {options.map(option => (
                <div
                    key={option}
                    className={`flex justify-start gap-[15px] w-full max-w-1/2 break-p-700:w-[312px] h-[60px] break-p-700:h-[85px] items-center rounded-[20px] ${option === currentOption
                        ? 'border border-solid border-sub-title dark:bg-sub-title'
                        : 'bg-disabled dark:bg-deep-dark dark:border dark:border-solid dark:border-sub-title'
                        } hover:cursor-pointer`}

                    onClick={() => setOption(option)}
                >
                    {
                        React.cloneElement(icon, {
                            className: `ml-[10px] w-[21px] h-[21px] break-p-700:h-[48px] break-p-700:w-[48px] stroke-sub-title ${option === currentOption ? 'dark:strokeWidth' : ''}`
                        })
                    }
                    <div class={`break-p-700:text-[24px] text-[14px] text-sub-title ${option === currentOption ? 'dark:text-white' : ''}`}>{option}</div>
                </div>
            ))}
        </div>
    </div>
);